export enum InvoiceCategory {
    Normal,
    Simplified,
    Aggregate
}